<template>
  <div class="user-info">
    <div class="user-info-header">
      <div class="user-info-header-left">
        <img class="avatar-img" src="@/assets/style/avatar-icon.png" alt="" />
        <div class="user-info-wrap">
          <span class="user-info-name">{{userInfo.username || "User"}}</span>
           <span class="user-info-phone">{{formatPhone(phone)}}</span>
        </div>
      </div>
      <div class="user-info-header-right" v-if="!infoErrorCode.includes(preCheckData.code)">资料已完善</div>
      <div class="user-info-header-right-uncomplete" @click="toIdCardBinding" v-else>
        <span>资料未完善</span>
        <img src="@/assets/style/order/right-icon.png" alt="">
      </div> 
    </div>
  </div>
</template>

<script>
import { formatPhone } from "@/common/index.js";
import { infoErrorCode } from "@/utils/const";

export default {
  name: "userInfo",
  data() {
    return {
      formatPhone,
      infoErrorCode,
      phone:localStorage.getItem("phone") || "", 

    };
  },
  methods: {
    toIdCardBinding() {
      this.$router.push({ name: "idCardBinding" });
    },
    toOrderDetails() {
      localStorage.setItem("actived", '2');
      this.$store.commit("setActivedTab", '2');
    },
     toBankCard() {
      this.$router.push({ name: "addBank" });
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.userInfo;
    },
    preCheckData() {
      return this.$store.state.preCheckData;
    },
  },
};
</script>

<style scoped lang="scss">
.user-info {
}
.user-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-info-header-left {
    display: flex;
    .avatar-img {
      width: 68px;
      height: 68px;
      border-radius: 50%;
      margin-right: 12px;
    }
    .user-info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      color: #333333;
      .user-info-name {
        font-size: 24px;
        font-weight: 500;
      }
      .user-info-phone {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .user-info-header-right {
    height: 28px;
    background: #EEEEEE;
    border-radius: 35px;
    padding: 0px 10px;
    font-size: 14px;
    color: #B2B2B2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-info-header-right-uncomplete{
    height: 28px;
    background: #FFEAE8;
    border-radius: 35px;
    padding: 0px 10px;
    font-size: 14px;
    font-weight: 500;
    color: #F24334;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      height: 10px;
      margin-left: 8px;
    }
  }
}
.user-info-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 26px;
  .user-info-content-left,.user-info-content-right{
    padding: 6px 20px 6px 12px;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 39%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    background: #fff;
    img{
      width: 52px;
      height: 52px;
    }
    .user-info-content-left-wrap,.user-info-content-right-wrap{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 16px;
      color: #333333;
      .user-info-content-left-desc,.user-info-content-right-desc{
        font-size: 10px;
        font-weight: 500;
        color: #D5D5D5;
        padding-top: 4px;
      }
    }
  }
}
</style>
